import { Injectable } from '@angular/core';
import {
  Router, Resolve, ActivatedRouteSnapshot
}                                 from '@angular/router';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
import { NeproseService } from '../services/neprose.service';

@Injectable({
  providedIn: 'root'
})
export class AdPlanResolverService implements Resolve<any>{

  constructor( private neproseService: NeproseService, private router: Router) { }

  resolve(): Observable<any> | Observable<never>{
    return this.neproseService.getAdPlans().pipe(
      take(1),
      mergeMap(adPlans=> {
        if (adPlans) {
          if(adPlans.adPlans){
            return of(adPlans.adPlans);
          }else{
            this.router.navigate(['']);
          }
        } else {
          this.router.navigate(['']);
        }
      })
    )
  }
}
